import React from 'react';

const TitleStatusButton = ({ status }) => {
    let statusText = status;
    let statusDescription = '';
    let badgeClass = '';

    switch (status) {
        case 'Inactive':
            statusDescription = 'INaudio does not currently have rights to sell this title';
            badgeClass = 'badge-secondary';
            break;
        case 'Drafted':
            statusDescription = 'Title is in draft mode in Passport, and has not been sent to INaudio';
            badgeClass = 'badge-warning';
            break;
        case 'Incomplete':
            statusDescription = 'Metadata has been submitted to INaudio, but Art and/or Audio are missing';
            badgeClass = 'badge-danger';
            break;
        case 'Submitted':
            statusDescription =
                'The full audiobook title has been submitted to INaudio, and has passed our automated QC.';
            badgeClass = 'badge-primary-blue';
            break;
        case 'Complete':
            statusDescription = 'The full audiobook title has been successfully ingested into INaudio’s systems.';
            badgeClass = 'badge-success';
            break;
        default:
    }

    return (
        <div className={`badge ${badgeClass}`} data-rh={statusDescription} data-rh-at="right">
            {statusText}
        </div>
    );
};

export default TitleStatusButton;
